// Customizable Area Start
export const Live = require("../assets/Live.svg");
export const EyeIcon = require("../assets/EyeIcon.svg");
export const CopyIcon = require("../assets/CopyIcon.svg");
export const LiveIcon = require("../assets/LiveIcon.svg");

// Customizable Area End
